import { BenefitsCardStructure } from 'common/components/benefits-card';
import { BATHROOM_CDN_PATH } from '../../../bathroom-constants';
import { Guarantee, Price, Projects, Repair, Showrooms } from './components';

export const BENEFITS_CARD_LIST: BenefitsCardStructure<unknown>[] = [
    {
      name: 'repair',
      elementName: 'Ремонт с нуля: всё включено',
      text: 'Ремонт с\u00A0нуля:\nвсё включено',
      icon: {
        src: `${BATHROOM_CDN_PATH}/benefits-card/repair-icon.png/repair-icon.png`,
        alt: 'Изготовление за 10 дней',
      },
      modal: Repair,
    },
    {
      name: 'nice-prices',
      elementName: 'Приятные цены',
      text: 'Приятные\nцены',
      icon: {
        src: `${BATHROOM_CDN_PATH}/benefits-card/calculator-icon.png/calculator-icon.png`,
        alt: 'Приятные цен',
      },
      modal: Price,
    },
    {
      name: 'guarantee',
      elementName: 'Гарантия качества',
      text: 'Гарантия\nкачества',
      icon: {
        src: `${BATHROOM_CDN_PATH}/benefits-card/guarantee-icon.png/guarantee-icon.png`,
        alt: 'Гарантия качества',
      },
      modal: Guarantee,
    },
    {
      name: 'projects',
      elementName: 'Более 1 млн проектов',
      text: 'Более 1 млн\nпроектов',
      icon: {
        src: `${BATHROOM_CDN_PATH}/benefits-card/benefits-icon.png/benefits-icon.png`,
        alt: 'Более 1 млн проектов',
      },
      modal: Projects,
    },
    {
      name: 'showrooms',
      elementName: 'Посмотреть вживую можно в магазинах',
      text: 'Посмотреть вживую можно в\u00A0магазинах',
      icon: {
        src: `${BATHROOM_CDN_PATH}/benefits-card/showrooms-icon.png/showrooms-icon.png`,
        alt: 'Посмотреть вживую можно в магазинах',
      },
      modal: Showrooms,
    },
  ];
